import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-environment-indicator',
    templateUrl: './environment-indicator.component.html',
    styleUrls: ['./environment-indicator.component.scss'],
})
export class EnvironmentIndicatorComponent {

    isDevEnvironment = environment.production == false && environment.staging == false;
    isTestEnvironment = environment.staging == true;
    isProdEnvironment = environment.production == true;

    constructor(
    ) { }


}
